/**
 * @fileoverview DELETE handler for the "/alloys/adjust/custom_events/:app_group_id/disconnect" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysAdjustCustomEventsAppGroupIdDisconnectCacheKeys } from "./constants";
import type {
  DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectProps,
  DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResult,
} from "./types";

export const deleteAlloysAdjustCustomEventsAppGroupIdDisconnect = reactQueryMutationAdapter(
  deleteAlloysAdjustCustomEventsAppGroupIdDisconnectCacheKeys,
  (
    props: DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectProps
  ): Promise<DeleteAlloysAdjustCustomEventsAppGroupIdDisconnectResult> => {
    return fetch(`/alloys/adjust/custom_events/${props.appGroupId}/disconnect`, "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
